module.exports = "<p *ngIf=\"!ivalidSignin\">\n  Loading...\n</p>\n<div *ngIf=\"ivalidSignin\">\n  <app-signin></app-signin>\n</div>"